import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format time from 01:55 to 01h55m
 * Usage:
 *  value | formatTime
 * Example:
 *  // time = '01:55'
 *  {{ time | formatTime  }}
 *  fromats to: '01h55m'
 */
@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {
  transform(value: string): string {
    if (value && value.indexOf(':') !== -1) {
      const split = value.split(':');
      return `${split[0]}h${split[1]}m`;
    }
    return value;
  }
}
